"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartHeader = void 0;
var react_1 = __importDefault(require("react"));
var Grid_1 = require("../Grid");
var Heading_1 = require("../Heading");
var styles_1 = require("../../styles");
var selector_1 = require("./selector");
function ChartHeader(props) {
    var title = props.title, rangeSelector = props.rangeSelector, onRangeChange = props.onRangeChange;
    var classes = styles_1.useStyles(createStyles).classes;
    if (!title && !rangeSelector)
        return null;
    return (react_1.default.createElement(Grid_1.Grid, { className: classes.header },
        title && (react_1.default.createElement(Grid_1.Cell, { flexGrow: 1 },
            react_1.default.createElement(Heading_1.Heading, { level: 3 }, title))),
        rangeSelector && (react_1.default.createElement(Grid_1.Cell, { flexGrow: 1 },
            react_1.default.createElement(selector_1.ChartRangeSelector, __assign({}, rangeSelector, { onChange: onRangeChange }))))));
}
exports.ChartHeader = ChartHeader;
var createStyles = function (theme) { return ({
    header: {
        borderBottom: "1px solid " + theme.pallete.divider,
        padding: '0.5rem',
        display: 'flex',
        h3: {
            margin: 0,
            display: 'inline-block',
        },
    },
}); };
//# sourceMappingURL=ChartHeader.js.map